MOVE.SRP = (function (MOVE) {
  "use strict";
  var init = function(){
    if (!$('.ads-wrapper').is(":visible")) {
    	$('.have-lb1-above-gnav').removeClass('have-lb1-above-gnav');
    }

    if (!MOVE.Medias.ab_test_lb1_v3_check()) {
      $('.ab_test_lb1list_v3').css("display","none");
      $('.ab_test_lb1map_v3').css("display","none");
      $('.ab_test_qvlb1_v3').css("display","none");
      $('.ab_test_fulllb1_v3').css("display","none");
    }
  };
  MOVE.SRP =
    {
      init: init,
    };
  return MOVE.SRP;
})(MOVE || {});



// WEBPACK FOOTER //
// ./srp/srp.js